import { LegalShell, LegalSection, LegalList } from "@/components/site/LegalShell";

export default function CookiePolicy() {
  return (
    <LegalShell
      title="Cookie Policy"
      updated="June 2026"
      seoTitle="Cookie Policy | AYOBELL"
      seoDesc="How the AYOBELL marketing website uses cookies and similar technologies."
    >
      <LegalSection>
        <p>This Cookie Policy explains how the AYOBELL marketing website (ayobell.com) uses cookies and similar technologies. Cookies are small files stored on your device that help websites function correctly.</p>
      </LegalSection>

      <LegalSection heading="Our approach at launch">
        <p>At launch, this website does not run analytics or session-recording tools and does not set non-essential analytics or advertising cookies. Only essential cookies required for the website to function are used.</p>
      </LegalSection>

      <LegalSection heading="Essential cookies">
        <p>Essential cookies support core functionality such as page navigation and security. These do not track you for marketing purposes.</p>
      </LegalSection>

      <LegalSection heading="Future use of analytics">
        <p>If we introduce analytics or performance tools in the future, we will update this Cookie Policy and provide an appropriate consent mechanism before any non-essential cookies are set.</p>
      </LegalSection>

      <LegalSection heading="Managing cookies">
        <p>You can control and delete cookies through your browser settings. Blocking some cookies may affect how the website works.</p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>For questions about our use of cookies, email <a className="text-teal-700 font-semibold" href="mailto:info@ayobell.com">info@ayobell.com</a>.</p>
      </LegalSection>
    </LegalShell>
  );
}
